import Tooltip from '@mui/material/Tooltip';

import StyledWrapper from '../../../IndividualProgram/style';
import { formatTimestamp } from '../../../../utils/dateUtils';

const BasicCellText = ({ cellValues, StartIcon, isLink, isDate, isDisabled, marginLeft }) => {
	const formattedText = isDate
		? formatTimestamp(cellValues?.formattedValue)
		: cellValues?.formattedValue;

	const isArchived = cellValues?.row?.is_archived;

	return (
		<Tooltip
			arrow
			placement="top"
			title={isArchived ? 'Archived Template' : cellValues?.formattedValue ? formattedText : 'n/a'}
		>
			<StyledWrapper.CellContainer
				marginLeft={marginLeft}
				data-testid={`cellContainer-${cellValues?.field}-${cellValues?.id}`}
			>
				{cellValues?.formattedValue != 0 && StartIcon && <StartIcon />}
				{!isLink ? (
					<StyledWrapper.CardRowInfo
						isDisabled={isDisabled}
						width={'100%'}
						data-testid={`rowInfo-${cellValues?.field}-${cellValues?.id}`}
					>
						{cellValues?.formattedValue
							? formattedText
							: cellValues?.formattedValue == 0
							? cellValues?.formattedValue
							: '--'}
					</StyledWrapper.CardRowInfo>
				) : (
					<StyledWrapper.CardRowInfoLink
						isDisabled={isDisabled}
						width={'100%'}
						data-testid={`rowLink-${cellValues?.field}-${cellValues?.id}`}
					>
						{cellValues?.formattedValue ? formattedText : '--'}
					</StyledWrapper.CardRowInfoLink>
				)}
			</StyledWrapper.CellContainer>
		</Tooltip>
	);
};

export default BasicCellText;
